<div class="media-list">
  <app-media-tile
    *ngFor="let media of medias; trackBy: trackById"
    [media]="media"
    class="media small-picture"
  ></app-media-tile>
</div>
